import axios from "axios";
import {getCookies} from "@/tools/cookie";

let baseUrl = process.env.VUE_APP_TRUCKERPATH;

const {userId, deviceId} = getCookies();

const headers = userId ? {
    userID: userId,
    deviceID: deviceId
} : {
    deviceID: deviceId
};

export function getPerferences() {
    console.log(headers, '============getPerferences')
    return axios.get(baseUrl + '/jobs-v2-api/v1/job/preference/get', {
        headers: headers
    });
}

export function addPerferences(data) {
    console.log(headers, '============addPerferences')
    return axios.post(baseUrl + '/jobs-v2-api/v1/job/preference/add', data, {
        headers: headers
    });
}
